import React, { useState } from 'react';
import {
  faUserClock,
  faChartArea,
  faTrophy,
  faFileExport,
  faChartPie,
  faCircleInfo,
  faBookOpenReader
} from '@fortawesome/free-solid-svg-icons';
import { faFileChartColumn, faScreenUsers, faChartColumn } from '@fortawesome/pro-solid-svg-icons';
import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { useExportSpreadSheetMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useAssignmentContext } from '../../../../context';
import Modal from '../../../../../../components/Modal';
import DropDown from '../../../../../../components/DropDown';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFerpaState,
  setFerpaState
} from '../../../../../../features/authentication/authSlice';
import {
  useGetClassesMutation
} from '../../../../../../features/authentication/authApiSlice';
import { useShowIdentificationFieldsMutation,
  useGetAssignmentIsStartedMutation
} from '../../../../../../features/authentication/assignApiSlice';
import { useExportFileMutation  } from '../../../../../../features/authentication/assignmentApislice';
import CustomToast from '../../../../../../components/Toast';

const items = [
  {
    id: 'timeOnTaskReport',
    icon: <FontAwesomeIcon icon={faUserClock} />,
    title: 'Time On Task Report',
    description: 'View time on task report.',
    to: 'timeOnTaskReport',
    comingSoon: false
  },
  {
    id: 'comprehensiveReport',
    icon: <FontAwesomeIcon icon={faChartArea} />,
    title: 'Assignment Comprehensive Report',
    description: 'View class progress with this assignment.',
    to: 'assignment_comprehensive_report',
    comingSoon: false
  },
  {
    id: 'cumulativeReport',
    icon: <FontAwesomeIcon icon={faScreenUsers} />,
    title: 'Class Cumulative Report',
    description: 'View class progress with this assignment.',
    to: 'class_cumulative_report',
    comingSoon: false
  },
  {
    id: 'scoreReport',
    icon: <FontAwesomeIcon icon={faTrophy} />,
    title: 'Scores Report',
    description: 'View scores in a printable window.',
    to: 'scores_report',
    comingSoon: false
  },
  {
    id: 'exportResponsesAsSpreadsheet',
    icon: <FontAwesomeIcon icon={faFileExport} />,
    title: 'Export all responses as spreadsheet file',
    description: '',
    to: 'export_all_responses_as_spreadsheet_file',
    comingSoon: false
  },
  {
    id: 'vocabularyStudySheet',
    icon: <FontAwesomeIcon icon={faBookOpenReader} />,
    title: 'Vocabulary Study Sheet',
    description: 'with vocabulary related to questions answered incorrectly.',
    to: 'vocabulary_study_sheet',
    comingSoon: false
  },
  {
    id: 'assignmentChangesReport',
    icon: <FontAwesomeIcon icon={faChartPie} />,
    title: 'Assignment Changes Report',
    description: '',
    to: 'assignment_changes_report',
    comingSoon: false
  },
  {
    id: 'exportOfflineUpload',
    icon: <FontAwesomeIcon icon={faChartArea} />,
    title: 'Export spreadsheet file for creating your own Offline Upload File',
    description: '',
    to: 'export_spreadsheet_file_for_creating_your_own_offline_upload_file',
    comingSoon: false
  },
  {
    id: 'classRetakeReport',
    icon: <FontAwesomeIcon icon={faChartColumn} />,
    title: 'Class Retake Report',
    description: 'Assignment Retake Level Report ',
    to: 'class_retake_report',
    comingSoon: false
  },
  {
    id: 'answerBreakdownReport',
    icon: <FontAwesomeIcon icon={faFileChartColumn} />,
    title: 'MC Answer Breakdown Report',
    description: '',
    to: 'mc_answer_breakdown_report',
    comingSoon: false
  }
];

const Reports = () => {
  const { assignmentId, assignmentName} = useAssignmentContext();
  const [exportSpreadSheet] = useExportSpreadSheetMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [isExport, setIsExport] = useState(false);
  const [showFerpa, setShowFerpa] = useState(false);
  const [classList, setClassList] = React.useState([]);
  const [selectedClassId, setSelectedClassId] = useState('-1');
  const [ferpaEnabled, setFerpaEnabled] = React.useState(useSelector(selectFerpaState));
  const [selectedReportId, setSelectedReportId] = React.useState(null);
  const [showIdentificationFields] = useShowIdentificationFieldsMutation();
  const [assignmentIsStarted] = useGetAssignmentIsStartedMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [exportOfflineUploadFile] = useExportFileMutation();
  const [getAllClasses] = useGetClassesMutation();

  async function loadClasses()
  {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    setClassList([
      {
        name: 'All Classes',
        id: -1,
        description: 'All Classes',
        isChecked: true
      },
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        description: item.className,
        isChecked: true
      }))
    ]);
  }

  const handleClassChange = (e) => {
    setSelectedClassId(e.target.value);
  };

  const exportAsSpreadSheetAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const option = {
          assignmentId: assignmentId,
          classId: selectedClassId
        };
        await exportSpreadSheet(option).unwrap();
      } catch (error) {
        if (error.data) {
          const CSVData = error.data;
          const blob = new Blob([CSVData], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `${assignmentName}.csv`;
          link.href = url;
          link.click();
          URL.revokeObjectURL(url);
        }
        setIsLoading(false);
      }
    }
  };

  const exportOfflineUpload = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: assignmentId,
          classId: selectedClassId
        };
        await exportOfflineUploadFile(options).unwrap();
      } catch (error) {
        if (error.data) {
          const CSVData = error.data;
          const blob = new Blob([CSVData], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = `OfflineUpload_${assignmentName}.csv`;
          link.href = url;
          link.click();
          URL.revokeObjectURL(url);
        }
        setIsLoading(false);
      }
    }
  };

  const handleFerpaChange = async (e) => {
    setFerpaEnabled(!ferpaEnabled);
    dispatch(
      setFerpaState({
        ferpaEnabled: e.target.checked
      })
    );
    const data = {
      condition: e.target.checked
    };
    try {
      await showIdentificationFields(data).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
      setClassList([
        {
          name: 'All Classes',
          id: -1,
          description: 'All Classes',
          isChecked: true
        },
        ...classes.map((item) => ({
          name: item.className,
          id: item.classID,
          description: item.className,
          isChecked: true
        }))
      ]);
    }else
    {
      loadClasses();
    }
  }, []);

  const reportItemOnClick = async (e) => {
    const currentTitle = e.currentTarget.id;
    const selectedItem = items.find((item) => item.title === currentTitle);
    setSelectedReportId(selectedItem.id);
    if(selectedItem.title === 'Export all responses as spreadsheet file' || selectedItem.title === 'Export spreadsheet file for creating your own Offline Upload File')
    {
      setIsExport(true);
      return;
    }
    else if(selectedItem.title === 'Scores Report' || selectedItem.title === 'MC Answer Breakdown Report' || selectedItem.title === 'Assignment Comprehensive Report')
    {
      try {
        const result = await assignmentIsStarted({
          assignment: assignmentId
        }).unwrap();
        if (!result) {
          CustomToast('The Assignment Has Not Started.', 'info');
          return;
        } 
      } catch (error) {
        console.log(error);
      }
    }
    setIsExport(false);
    navigate(selectedItem.to);
  };

  return (
    <>
      <div className="white-card">
        <div className="row justify-content-center">
          {items.map((item, index) => {
            return (
              <div
                id={item.title}
                key={index}
                className= {`position-relative col-sm-6 col-md-4 col-lg-3 mb-4  ${!item.comingSoon ? 'cursor-pointer':''} `}
                onClick={reportItemOnClick}>
                {item.comingSoon && <div className="comingSoonOverlay">Coming Soon!</div>}
                <div className="report-box d-flex flex-column h-100 align-items-center">
                  <span className="d-block mb-3">{item.icon}</span>
                  <h4>{item.title}</h4>
                  <p className="mb-0">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {isExport && ( // Render the Modal component when isExport is true
        <Modal
          contentWidth="700px"
          isOpen={isExport}
          titleName={selectedReportId == 'exportResponsesAsSpreadsheet'?'Export All Responses'
            : 'Export Offline Upload'
          }
          onClose={() => {
            setIsExport(false);
            setShowFerpa(false);
          }}>
          {selectedReportId == 'exportResponsesAsSpreadsheet' &&(
            <button
              onClick={() => setShowFerpa(!showFerpa)}
              className="btn-link primary-link"
              style={{ float: 'right' }}>
              <FontAwesomeIcon icon={faCircleInfo} /> FERPA
            </button>
          )}
          {showFerpa && (
            <div className="d-flex flex-row ferpaMessage">
              <div className="d-flex flex-column">
                <p>
                  Student identification information should not be printed or displayed publicly or
                  emailed as per FERPA requirements.
                </p>
                <a
                  href="https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
                  target="_blank"
                  className="link-orange"
                  style={{ marginBottom: '16px' }}
                  rel="noreferrer">
                  Family Educational Rights and Privacy Act (FERPA)
                </a>
                <Form.Check
                  type="checkbox"
                  id="displayStudentNames"
                  className="d-flex flex-row align-items-center">
                  <Form.Check.Input
                    type="checkbox"
                    defaultChecked={ferpaEnabled}
                    style={{ marginRight: '5px' }}
                    onClick={(e) => handleFerpaChange(e)}
                  />
                  <Form.Check.Label>Display Student Names/Identification</Form.Check.Label>
                </Form.Check>
              </div>
              <FontAwesomeIcon
                color="#525252"
                style={{ fontSize: '20px', cursor: 'pointer' }}
                icon={faX}
                onClick={() => setShowFerpa(false)}
              />
            </div>
          )}      
          <div>
            Class
            <DropDown
              value={classList}
              label=""
              selectedValue={selectedClassId ? selectedClassId : ''}
              onChangeHandler={(e) => handleClassChange(e)}
            />
            <br></br>
            {selectedReportId == 'exportResponsesAsSpreadsheet' && (<p>
              Select Class And Press The Submit Button To Generate Report For The Selected Class.
            </p>)}
            {selectedReportId == 'exportOfflineUpload' && (<p>
              Select Class And Press The Submit Button To Export Spreadsheet File For Offline Upload.
            </p>)}
            <div
              className="d-flex justify-content-end mt-5 gap-3 align-items-center">
              <button
                className="btn btn-castleGray px-4"
                onClick={() => {
                  setIsExport(false);
                }}>
                Cancel
              </button>
              <button
                className="btn btn-castleRed px-4"
                onClick={selectedReportId == 'exportResponsesAsSpreadsheet'?exportAsSpreadSheetAsync:exportOfflineUpload}
                disabled={isLoading}>
                {isLoading ? 'Downloading...' : 'Submit'}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Reports;
